<template>
  <div class="contentHome">
    <div class="centerPage">
      <div class="login">
        <!--        <div class="leftBG">
                  <strong>欢迎使用</strong>
                  <h1>心理亦笙</h1>
                  <div class="content">
                    <span><i class="el-icon-check"></i>资深医生</span>
                    <span><i class="el-icon-check"></i>线上咨询</span>
                    <span><i class="el-icon-check"></i>心理测试</span>
                    <span><i class="el-icon-check"></i>公益科普</span>
                    <span><i class="el-icon-check"></i>地区资源</span>
                  </div>
                </div>-->
        <el-form ref="userForm" :model="user" v-loading="formLoading">
          <h2 class="title">忘记密码</h2>
          <div v-show="!nextStepShow">

            <div class="elInput">
              <el-radio-group v-model="findWay">
                <el-radio label="sms">手机号码</el-radio>
                <el-radio label="email">邮箱</el-radio>
              </el-radio-group>
            </div>

            <div class="elInput" v-if="findWay=='sms'">
              <el-input type="tel" v-model="user.mobile" placeholder="手机号码"></el-input>
            </div>

            <div class="elInput" v-if="findWay=='email'">
              <el-input type="tel" v-model="user.email" placeholder="邮箱"></el-input>
            </div>

            <div v-show="captchaShow" class="flex elInput">
              <el-input type="text" autocomplete='new-password' v-model="user.code" placeholder="图形验证码"></el-input>
              <div class="flex getCode" @click="initCaptcha">
                <img :src="captcha.src" alt="图形验证码" width="130" style="cursor: pointer;">
              </div>
            </div>

            <div class="flex elInput getCodeInput">
              <el-input type="text" v-if="findWay=='sms'" autocomplete='new-password' v-model="user.smsCode"
                        placeholder="短信验证码"></el-input>
              <el-input type="text" v-if="findWay=='email'" autocomplete='new-password' v-model="user.emailCode"
                        placeholder="邮箱验证码"></el-input>
              <a href="javaScript:void(0);" @click="sendCode" v-if="waitSecond<0">获取验证码</a>
              <a href="javaScript:void(0);" v-if="waitSecond>=0">{{ waitSecond }}s后重新获取</a>
            </div>
            <div class="elInput">
              <el-button type="primary" @click="nextStep" :loading="stepLoading">下一步</el-button>
            </div>
          </div>
          <div v-show="nextStepShow">
            <div class="elInput">
              <el-input type="password" v-model="user.password" placeholder="设置新密码"></el-input>
            </div>
            <div class="elInput">
              <el-input type="password" autocomplete='new-password' v-model="user.pwd" placeholder="确认新密码"></el-input>
            </div>
            <div class="elInput flex ">
              <el-button type="primary" @click="confirmReset">重置</el-button>
            </div>
          </div>

          <div class="elInput flex select">
            <span><router-link to="/login">返回登录>></router-link></span>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import base from '@/api/common';
import qs from 'qs';

export default {
  name: "forget",
  data() {
    return {
      findWay: 'sms',
      user: {
        mobile: '',
        email: '',
        password: '',
        code: '',
        pwd: '',
        smsCode: '',
        emailCode: '',
      },
      nextStepShow: false,
      captchaShow: false,

      captcha: {
        key: '',
        src: ''
      },
      waitSecond: -1,

      stepLoading: false,
      formLoading: false,
    }
  },
  mounted() {
    this.initCaptcha();
  },
  methods: {
    initCaptcha() {
      this.$ajax.post(base.api.captcha).then(res => {
        if (res.data.status === 'success') {
          this.captcha.key = res.data.token;
          this.captcha.src = res.data.data;
        }
      });
    },
    sendCode() {
      let url, params;
      if (this.findWay === 'sms') {
        if (!base.reg.mobile.test(this.user.mobile)) {
          this.$message.warning('请输入正确的手机号码');
          return;
        }
        url = base.api.sms.resetPwd;
        params = {
          token: this.captcha.key,
          code: this.user.code,
          mobile: this.user.mobile
        };
      } else if (this.findWay === 'email') {
        if (!base.reg.email.test(this.user.email)) {
          this.$message.warning('请输入正确的邮箱');
          return;
        }
        url = base.api.email.resetPwd;
        params = {
          token: this.captcha.key,
          code: this.user.code,
          email: this.user.email
        };
      } else {
        return;
      }
      this.initCaptcha();
      this.captchaShow = true;
      if ($.trim(this.user.code).length === 0) {
        this.$message.warning("请输入图形验证码");
        return;
      } else if ($.trim(this.user.code).length !== 4) {
        this.$message.warning("图形验证码不正确");
        return;
      }
      this.waitSecond = 60;
      let timer = setInterval(_ => {
        this.waitSecond--;
        if (this.waitSecond < 0) {
          clearInterval(timer);
        }
      }, 1000);
      this.$ajax.post(url, qs.stringify(params)).then(res => {
        if (res.data.status === 'success') {
          this.$message.success("发送成功");
          this.captchaShow = false;
        } else {
          this.$message.error(res.data.message);
          this.initCaptcha();
        }
      });
    },
    nextStep() {
      let url;
      if (this.findWay === 'sms') {
        if (!base.reg.mobile.test(this.user.mobile)) {
          this.$message.warning('请输入正确的手机号码');
          return;
        }
        if ($.trim(this.user.smsCode).length === 0) {
          this.$message.warning("请输入短信验证码");
          return;
        } else if ($.trim(this.user.smsCode).length !== 6) {
          this.$message.warning("短信验证码不正确");
          return;
        }
        url = base.api.checkMobile_reset;
      } else if (this.findWay === 'email') {
        if (!base.reg.email.test(this.user.email)) {
          this.$message.warning('请输入正确的邮箱');
          return;
        }
        if ($.trim(this.user.emailCode).length === 0) {
          this.$message.warning("请输入邮箱验证码");
          return;
        } else if ($.trim(this.user.emailCode).length !== 6) {
          this.$message.warning("邮箱验证码不正确");
          return;
        }
        url = base.api.checkEmail_reset;
      }
      this.stepLoading = true;
      this.$ajax.post(url, qs.stringify({
        mobile: this.user.mobile,
        smsCode: this.user.smsCode,
        email: this.user.email,
        emailCode: this.user.emailCode
      })).then(res => {
        if (res.data.status === 'success') {
          this.nextStepShow = true;
        } else {
          this.$message.error(res.data.message);
        }
        this.stepLoading = false;
      }).catch(err => {
        this.stepLoading = false;
        console.error(err);
      });
    },
    confirmReset() {
      let that = this;
      if (!base.reg.pass.test(this.user.password)) {
        this.$message.error("密码不符合规范，长度在6~18之间，只能包含字母、数字");
        return;
      }
      if (this.user.password !== this.user.pwd) {
        this.$message.error("两次输入的密码不一致");
      }
      this.formLoading = true;
      let url, params;
      if (this.findWay === 'sms') {
        url = base.api.resetPwd_mobile;
        params = {
          mobile: this.user.mobile,
          smsCode: this.user.smsCode,
          password: this.user.password
        };
      } else if (this.findWay === 'email') {
        url = base.api.resetPwd_email;
        params = {
          email: this.user.email,
          emailCode: this.user.emailCode,
          password: this.user.password
        };
      } else {
        return;
      }
      this.$ajax.post(url, qs.stringify(params)).then(res => {
        if (res.data.status === 'success') {
          this.$message.success("修改成功");
          localStorage.clear();
          setTimeout(_ => {
            that.$router.push('/login');
            location.reload();
          }, 2000);
        } else {
          this.$message.error(res.data.message);
          this.formLoading = false;
        }
      }).catch((err) => {
        console.error(err);
        this.$message.error('操作失败');
      });
    },
  }
}
</script>
<style scoped lang="scss">
@import '../assets/css/login.scss';

.login .select {
  justify-content: center;
}

.login {
  width: 450px;

  .el-form {
    width: 90%;
  }
}
</style>
